import React from 'react';

// Placeholder icon (replace with actual icon component later)
const checkIcon = '✔️';

const NetworkingPreferences: React.FC = () => {
  // Static content based on the original HTML template
  // TODO: Make this dynamic based on user data if required
  const preferences = [
    'Mentoring',
    'Project Collaboration',
    'Technical Discussions',
    'Job Opportunities'
  ];

  return (
    <div className="card border-0 shadow-sm">
        <div className="card-header bg-white py-3">
            <h5 className="mb-0 fw-bold">Networking Preferences</h5>
        </div>
        <div className="card-body p-4">
            <p className="mb-3">I'm interested in connecting for:</p>
            <div className="row">
                {/* Split preferences into two columns */}
                <div className="col-md-6">
                    {preferences.slice(0, 2).map((pref, index) => (
                        <div key={index} className="d-flex align-items-center mb-3">
                            <div className="rounded-circle bg-success bg-opacity-10 p-2 me-3">
                                {/* TODO: Replace with actual icon component */}
                                <span className="text-success">{checkIcon}</span>
                            </div>
                            <span>{pref}</span>
                        </div>
                    ))}
                </div>
                <div className="col-md-6">
                    {preferences.slice(2, 4).map((pref, index) => (
                        <div key={index + 2} className="d-flex align-items-center mb-3">
                            <div className="rounded-circle bg-success bg-opacity-10 p-2 me-3">
                                 {/* TODO: Replace with actual icon component */}
                                 <span className="text-success">{checkIcon}</span>
                            </div>
                            <span>{pref}</span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    </div>
  );
};

export default NetworkingPreferences; 